export function hasSubAgentNodes(nodes) {
  return (nodes || []).some((n) => n.type === 'sub_agent_container');
}

// Content equal to this token means a forms node tracks the central
// agentflow/prompt_templates/forms.txt instead of holding a frozen copy.
export const FORMS_TEMPLATE_MARKER = '{{FORMS}}';

/**
 * Replaces global template markers (e.g. {{FORMS}}) with server-provided template
 * content, mirroring the backend's inject_templates_into_prompt. Markers without
 * content and unknown tokens are left untouched.
 */
export function substituteTemplateMarkers(content, templates) {
  return content.replace(/\{\{([A-Z0-9_]+)\}\}/g, (token, name) => templates?.[name] ?? token);
}

export function toSnakeCase(str) {
  return str.replace(/([A-Z])/g, (m, c, i) => (i > 0 ? '_' : '') + c.toLowerCase());
}

/**
 * Expands $class.method references in prompt content using parameter bindings from tool nodes.
 * Used at build time and for prompt preview.
 */
export function buildPromptContent(content, nodes) {
  return content.replace(/\$(\w+)\.(\w+)/g, (match, classSnake, methodName) => {
    const classNode = (nodes || []).find(
      (n) => n.type === 'tool_class' && toSnakeCase(n.data.toolClass) === classSnake
    );
    if (classNode) {
      const method = (classNode.data.methods || []).find((m) => m.name === methodName);
      if (method) {
        const entries = Object.entries(method.parameterBindings || {});
        if (!entries.length) return `${methodName}()`;
        const params = entries.map(([k, v]) => `  ${k}: ${v}`).join(',\n');
        return `${methodName}(\n${params}\n)`;
      }
    }
    return match;
  });
}
